<template>
  <GravManagerWrapper
    :id="id"
    :componentName="componentName"
    :properties="props"
    :xOffset="-15"
    :yOffset="-15"
  >
    <component :is="CarouselWidget" v-bind="{ style: $attrs.style, ...changableProps }">
      <template v-for="slotName in Object.keys($slots)" #[slotName]="slotProps">
        <slot :name="slotName" v-bind="slotProps" />
      </template>
    </component>
  </GravManagerWrapper>
</template>

<script setup lang="ts">
import { useChangableProps } from '@/composables/useChangableProps';
import { CarouselWidgetProps } from './CarouselWidget.ts';
import CarouselWidget from './CarouselWidget.vue';
import GravManagerWrapper from './GravManagerWrapper.vue';

const componentName = 'ui-carousel-widget';
const $slots = defineSlots<Record<string, unknown>>();

const props = defineProps<CarouselWidgetProps>();
const changableProps = useChangableProps(componentName, props);

</script>
